import { Component, EventEmitter, Injector, Input, OnInit, Output,  } from '@angular/core';
import { ButtonInfo } from '../helperClasses/value-and-display.class';
import { Validators } from '../../Validators/validators';
import { BaseDialog } from '../../Forms/Dialog-types/base-dialog';
import { IValidator } from 'src/app/Directives/directives.helper';
import { MatIcon } from '@angular/material/icon';
import { SelectionBoxComponent } from '../selection-box/selection-box.component';
import { ColorPickerComponent } from '../color-picker/color-picker.component';
import { InputBoxComponent } from '../input-box/input-box.component';


export enum StatusShape {
  Circle = 'circle',
  Square = 'square',
  Triangle = 'triangle'
}

@Component({
    selector: 'ins-layer-status-design-picker',
    templateUrl: './layer-status-design-picker.component.html',
    styleUrls: ['./layer-status-design-picker.component.scss', '../shared-UI-components.scss'],
    imports: [MatIcon, SelectionBoxComponent, ColorPickerComponent, InputBoxComponent]
})
export class LayerStatusDesignPickerComponent extends BaseDialog implements OnInit {
  @Input() bgColor: string;
  @Input() shape: StatusShape = StatusShape.Circle;
  @Input() status: number;
  @Input() selectedStatusList: number[] = [];
  @Input() isSavedStatus: boolean = false;
  @Output() designChange: any = new EventEmitter<any>();
  @Output() removeDesign: any = new EventEmitter<any>();

  public openColorPicker: boolean = false;
  public showSelector: boolean = false;
  public selectorPosition: any = {};

  public shapeOptions: ButtonInfo[] = [];
  public statusOptions: ButtonInfo[] = [];

  public disableStatusSelection: boolean = false;
  public colorCodeValidators: IValidator[] = [];
  constructor(public injector: Injector, public validators: Validators) {
    super(injector);
    this.shapeOptions.push(
      new ButtonInfo(StatusShape.Circle, 'Circle'),
      new ButtonInfo(StatusShape.Square, 'Square'),
      new ButtonInfo(StatusShape.Triangle, 'Triangle')
    );

    this.colorCodeValidators = [{objectID: 'input', regEx: '^([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$',
      displayText: 'Enter a valid hex color code.'},
      validators.Required];
  }

  public onChanges(): void { }

  public ngOnInit(): void {
    this.bgColor = `${this.bgColor ? this.bgColor : 'FFFFFF'}`;
    this.shape = this.shape ? this.shape : StatusShape.Circle;
    this.disableStatusSelection = !!this.status; 

    this.statusOptions = [];
    for (let i = 1; i <= 12; i++) {
      if (!this.selectedStatusList[i-1] || i === this.status) {
        this.statusOptions.push(new ButtonInfo(i, i.toString()));
      }
    }
    
    if (!this.status) {
      this.status = this.statusOptions[0].value;
    }
  }

  public toggleColorPallete(opened: boolean): void {
    this.openColorPicker = opened;
  }

  public removeStatus(): void {
    this.removeDesign.emit({
      status: this.status,
      bgColor: this.bgColor,
      shape: this.shape
    });
  }

  public addStatus(): void {
    this.designChange.emit({
      status: this.status,
      bgColor: this.bgColor,
      shape: this.shape
    });
  }

  public defineDialogModel(): void {
    this.dialogModel.initModel(
      ['bgColor', this.bgColor],
      ['shape', this.shape],
      ['status', this.status]
    );
  }

  public closePopup(): void {
   this.designChange.emit(null)
  }
 
}
